import { observer } from 'mobx-react-lite';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { getIconCSSForFileProvider } from 'owa-fileprovider-icon';
import loc, { format } from 'owa-localize';
import type AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import * as React from 'react';
import { FilePicker_Remove, FilePicker_Remove_Label } from './FileProviderView.locstring.json';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { isProviderBeingRemoved } from 'owa-fileprovider-store/lib/selectors/isProviderBeingRemoved';

const styles = require('./FileProviderView.scss');

export interface FileProviderViewProps {
    providerType: AttachmentDataProviderType;
    providerName: string;
    onRemoveClicked?: () => void;
    displayText: string;
}

const FileProviderView = observer(function FileProviderView(props: FileProviderViewProps) {
    const { providerType, providerName, displayText, onRemoveClicked } = props;

    const containerStyle = onRemoveClicked ? styles.bigContainer : styles.smallContainer;
    const icon = getIconCSSForFileProvider(providerType);
    const title = format(loc(FilePicker_Remove_Label), providerName);
    const isBeingRemoved = isProviderBeingRemoved(providerType);

    return (
        <div className={containerStyle}>
            <div className={styles.iconContainer}>{icon}</div>

            <div className={styles.contentContainer}>
                <div className={styles.textContainer}>
                    <div className={styles.displayText}>{displayText}</div>
                    <div className={styles.providerName}>{providerName}</div>
                </div>
                {onRemoveClicked && (
                    <div className={styles.actions}>
                        {isBeingRemoved && <Spinner />}
                        {!isBeingRemoved && (
                            <DefaultButton
                                className={styles.removeButton}
                                onClick={onRemoveClicked}
                                aria-label={title}>
                                {loc(FilePicker_Remove)}
                            </DefaultButton>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
});
export default FileProviderView;
